var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.kpiData),function(item){return _c('v-row',{key:item.key,staticClass:"body-1 font-weight-bold",attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('span',{staticClass:"grey--text text-darken-1"},[_vm._v(_vm._s(item.key)+": ")]),_vm._v(_vm._s(_vm.formatValue(item)))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }